import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React from "react";
import {
  primaryButtonStyles,
  textButtonStyles,
} from "../../../../../Constants/buttonStyles";
import { dialogStyles } from "../../../../../Constants/dialogStyles";
import { inputStyles } from "../../../../../Constants/inputStyles";

const CreateNewUserDialog = ({
  openDialog,
  handleChange,
  newUser,
  isAlphabetic,
  isValidEmail,
  isValidPassword,
  handleClose,
  handleAddUser,
  isFormValid,
  areFieldsFilled,
}) => {
  return (
    <Dialog
      open={openDialog}
      // onClose={handleClose}
      PaperProps={{ sx: dialogStyles.dialogRoot }}
      disableEscapeKeyDown
      fullWidth
    >
      <DialogTitle sx={{ ...dialogStyles.dialogTitle, mb: 2 }}>
        Add a new user
      </DialogTitle>
      <DialogContent sx={dialogStyles.dialogContent}>
        <TextField
          autoFocus
          margin="dense"
          name="first_name"
          placeholder="First Name"
          type="text"
          fullWidth
          variant="outlined"
          value={newUser.first_name}
          onChange={handleChange}
          sx={inputStyles.textField}
          error={newUser.first_name && !isAlphabetic(newUser.first_name)}
          helperText={
            newUser.first_name && !isAlphabetic(newUser.first_name)
              ? "First name should contain only letters"
              : ""
          }
        />
        <TextField
          margin="dense"
          name="last_name"
          placeholder="Last Name"
          type="text"
          fullWidth
          variant="outlined"
          value={newUser.last_name}
          onChange={handleChange}
          sx={inputStyles.textField}
          error={newUser.last_name && !isAlphabetic(newUser.last_name)}
          helperText={
            newUser.last_name && !isAlphabetic(newUser.last_name)
              ? "Last name should contain only letters"
              : ""
          }
        />
        <TextField
          margin="dense"
          name="email"
          placeholder="Email Address"
          type="email"
          fullWidth
          variant="outlined"
          value={newUser.email}
          onChange={handleChange}
          sx={inputStyles.textField}
          error={newUser.email && !isValidEmail(newUser.email)}
          helperText={
            newUser.email && !isValidEmail(newUser.email)
              ? "Enter a valid email address"
              : ""
          }
        />
        <TextField
          margin="dense"
          name="password"
          placeholder="Password"
          type="password"
          fullWidth
          variant="outlined"
          value={newUser.password}
          onChange={handleChange}
          sx={inputStyles.textField}
          error={newUser.password && !isValidPassword(newUser.password)}
          helperText={
            newUser.password && !isValidPassword(newUser.password)
              ? "Password must be at least 8 characters, including at least one digit, and allowed special characters (/-*@!#_)"
              : ""
          }
        />
        <Select
          value={newUser.privilege}
          margin="dense"
          name="privilege"
          onChange={handleChange}
          fullWidth
          variant="outlined"
          displayEmpty
          sx={inputStyles.select}
        >
          <MenuItem value="" disabled>
            Privilege
          </MenuItem>
          <MenuItem value="owner">Owner</MenuItem>
          <MenuItem value="admin">Admin</MenuItem>

          <MenuItem value="member">Member</MenuItem>
        </Select>

        <Select
          value={newUser.permissions}
          margin="dense"
          name="permissions"
          onChange={handleChange}
          fullWidth
          variant="outlined"
          displayEmpty
          sx={{
            ...inputStyles.select,
            my: 2,
          }}
        >
          <MenuItem value="" disabled>
            Permissions
          </MenuItem>
          <MenuItem value="1">Public</MenuItem>
          <MenuItem value="2">Confidential</MenuItem>
          <MenuItem value="3">Secret</MenuItem>
        </Select>
      </DialogContent>
      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mx: 2,
        }}
      >
        <Button onClick={handleClose} sx={textButtonStyles}>
          Cancel
        </Button>
        <Button
          onClick={handleAddUser}
          sx={primaryButtonStyles}
          disabled={!areFieldsFilled() || !isFormValid()}
        >
          Add User
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateNewUserDialog;
